/**
 * Georgia Weather Network on-air mark — the GA outline with the yellow lightning bolt,
 * identical to the broadcast TvBanner icon (TvFrame.jsx) and the Pillow render (tv_brand.py).
 * Use anywhere the signature broadcast brand should appear on the website.
 */
export const TV_BLUE = "#1f63c9";
const GA_ICON = "M6.8 0.3 L52.1 0.0 L47.9 6.7 L53.4 11.1 L56.3 11.4 L62.0 22.5 L66.7 25.8 L68.8 29.6 L72.8 32.8 L74.9 37.8 L81.3 42.9 L82.9 51.2 L86.7 54.6 L88.3 62.1 L93.2 64.1 L88.0 70.7 L85.1 81.6 L83.1 83.8 L82.3 92.4 L72.0 90.8 L71.3 99.9 L69.2 100.0 L67.7 95.4 L20.3 92.4 L15.9 82.2 L17.0 74.4 L15.2 69.3 L16.9 61.6 L19.4 58.9 L17.7 57.6 L17.8 53.6 L14.5 45.9 Z";
const BOLT = "M57 18 36 58h17l-4 30 24-44H56l5-26z";

export default function GwnMark({ size = 48, className = "" }) {
  return (
    <svg viewBox="-4 -4 108 108" width={size} height={size} className={`shrink-0 ${className}`} aria-hidden="true" data-testid="gwn-mark">
      <path d={GA_ICON} fill="#0a0f1c" stroke={TV_BLUE} strokeWidth="5" strokeLinejoin="round" />
      <path d={BOLT} fill="#ffd60a" stroke="#0a0f1c" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
